import React, { useState, useEffect } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate } from 'react-router-dom';

const AddMeterModule = () => {
    const [inReading, setInReading] = useState('');
    const [date, setDate] = useState(''); // We will set this value in useEffect
    const [inImage, setInImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // Set default date to today's date
    useEffect(() => {
        const today = new Date().toISOString().split('T')[0]; // Gets today's date in YYYY-MM-DD format
        setDate(today); // Set the default date to today's date
    }, []);

    // Handle input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'in_reading') setInReading(value);
        if (name === 'date') setDate(value);
    };

    // Handle file input for the image
    const handleFileChange = (e) => {
        const { name, files } = e.target;
        if (name === 'in_image') setInImage(files[0]);
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        const formData = new FormData();
        formData.append('in_reading', inReading);
        formData.append('date', date);
        if (inImage) formData.append('in_image', inImage);

        fetch(`${BASE_URL}metermodule`, {
            method: 'POST',
            body: formData,
        })
            .then((response) => response.json())
            .then((data) => {
                setLoading(false);
                if (data.status === 1) {
                    alert('Meter module created successfully');
                    navigate('/MeterModuleList'); // Redirect to the meter module list page
                } else {
                    alert('Failed to create meter module');
                }
            })
            .catch((error) => {
                setLoading(false);
                console.error('Error:', error);
                alert('Error creating meter module');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Meter Module</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Add a new Meter Module</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    {/* In Reading Field */}
                                    <div className="mb-3">
                                        <label htmlFor="in_reading" className="form-label">In Reading</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="in_reading"
                                            name="in_reading"
                                            value={inReading}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>

                                    {/* In Image Field */}
                                    <div className="mb-3">
                                        <label htmlFor="in_image" className="form-label">In Image</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            id="in_image"
                                            name="in_image"
                                            accept="image/*"
                                            onChange={handleFileChange}
                                            required
                                        />
                                    </div>

                                    {/* Hidden Date Field (defaults to today's date) */}
                                    <div className="mb-3 d-none">
                                        <label htmlFor="date" className="form-label">Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="date"
                                            name="date"
                                            value={date}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>

                                    {/* Submit Button */}
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={loading}
                                    >
                                        {loading ? 'Adding...' : 'Add Meter Module'}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddMeterModule;
